// extracted by mini-css-extract-plugin
module.exports = {"expanded-container":"_02712f2b3b--expanded-container--oy3TD","container":"_02712f2b3b--container--IV1I1","link":"_02712f2b3b--link--KUUkM"};